module.exports = __webpack_public_path__ + "img/timer.264e2c0e.svg";